import { render, staticRenderFns } from "./DatosSolicitud.vue?vue&type=template&id=4e83a9c4&scoped=true&"
import script from "./DatosSolicitud.vue?vue&type=script&lang=js&"
export * from "./DatosSolicitud.vue?vue&type=script&lang=js&"
import style0 from "./DatosSolicitud.vue?vue&type=style&index=0&id=4e83a9c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e83a9c4",
  null
  
)

export default component.exports